module.exports = __webpack_public_path__ + "img/IMG_1331.9456379c.jpg";